"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconError = _interopRequireDefault(require("../../icons/icon-error.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ErrorMessage = function ErrorMessageComponent(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "error-container"
  }, /*#__PURE__*/_react["default"].createElement(_iconError["default"], {
    className: "error-container__icon"
  }), message);
};

ErrorMessage.propTypes = {
  message: _propTypes["default"].string.isRequired
};
var _default = ErrorMessage;
exports["default"] = _default;